import e from"react";const o=o=>{e.useEffect(()=>{const e=window.getComputedStyle(document.body).overflow;return document.body.style.overflow=o?"hidden":"hidden"===e?"":e,()=>{document.body.style.overflow=e}},[o])};export{o as default};
